export default __webpack_public_path__ + "images/flight-icon.eea03cb.png";